import { useEffect } from "react";
import { useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";
import { authService } from "../../services/authService";

export default function SignIn() {
  const navigate = useNavigate();

  useEffect(() => {
    // Verifica se o usuário já está autenticado
    if (authService.isAuthenticated()) {
      // Redireciona para a dashboard
      navigate("/");
    }
  }, [navigate]);

  return (
    <>
      <PageMeta
        title="Entrar - Sellyo"
        description="Faça login para gerenciar suas vendas e produtos"
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
